import { Stack } from 'expo-router';

import GoBackButton from '@/components/buttons/GoBackButton';
import Title from '@/components/Title';
import PlatformContainer from '@/components/web/PlatformContainer';
import { i18n } from '@/utils/i18n';

export default function QuestionsLayout() {
  return (
    <PlatformContainer contentCustomClassnames="flex flex-col">
      <Stack>
        <Stack.Screen name="list/[npoId]" />
        <Stack.Screen name="ask_question" />
        <Stack.Screen
          name="add_question_answer"
          options={{
            headerTitle: () => <Title label={i18n.t('question.add.title')} />,
            headerShadowVisible: false,
            headerLeft: () => <GoBackButton />,
            headerBackButtonDisplayMode: 'minimal'
          }}
        />
        <Stack.Screen name="npoLightRatingQuestions" />
      </Stack>
    </PlatformContainer>
  );
}
